
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiOwnShipNoCommandO as ObiOwnShipNoCommandOElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-own-ship-no-command-o.js';
 
 
 

 
 export const ObiOwnShipNoCommandO = createComponent({
   react: React,
   tagName: 'obi-own-ship-no-command-o',
   elementClass: ObiOwnShipNoCommandOElement,
   events: {
     
   }
  });
 
 